/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Delete/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Content from './Content/index'
import No from './No/index'
import Popover from 'DesignSystem/Popover/index'
import PopoverContentHover from 'DesignSystem/Popover/PopoverContentHover/index'
import PopoverTrigger from 'DesignSystem/Popover/PopoverTrigger/index'
import React from 'react'
import Tooltip from 'DesignSystem/Tooltip/index'
import TysiaButton from 'DesignSystem/TysiaButton/index'
import TysiaButtonIcon from 'DesignSystem/TysiaButton/TysiaButtonIcon/index'
import Tysiav2DeleteFilled from 'DesignSystem/Svgs/Tysiav2DeleteFilled/index'



/** @type {import('Simple/types.js').View} */
export default function Delete({
  children,
  viewPath = "/DesignSystem/PaymentProvider/PaymentProviderMethod/Content/ReusableMethods/Method/Delete"
  
}) {
  let flow = fromFlow.useFlow()
  let flowValue = fromFlow.useFlowValue(viewPath) || 'PopoverTrigger'
  let setFlowTo = fromFlow.useSetFlowTo(viewPath)
let dtSpaceXs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xs'
        })
let authApiRoleValueData = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'api_role',
})
let reusableMethodsPaymentsTokensValueData = fromData.useDataValue({ viewPath,
context: 'reusable_methods',
path: 'payments_tokens',
})
let aggregateData = fromHelpers.isDisabled(authApiRoleValueData, reusableMethodsPaymentsTokensValueData)
let authApiRoleValueData1 = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'api_role',
})
let reusableMethodsPaymentsTokensValueData1 = fromData.useDataValue({ viewPath,
context: 'reusable_methods',
path: 'payments_tokens',
})
let aggregateData1 = fromHelpers.isDisabled(authApiRoleValueData1, reusableMethodsPaymentsTokensValueData1)
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
let dtColorsNeutral300 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.300'
        })
let authApiRoleValueData2 = fromData.useDataValue({ viewPath,
context: 'auth',
path: 'api_role',
})
let reusableMethodsPaymentsTokensValueData2 = fromData.useDataValue({ viewPath,
context: 'reusable_methods',
path: 'payments_tokens',
})
let aggregateData2 = fromHelpers.isDisabled(authApiRoleValueData2, reusableMethodsPaymentsTokensValueData2)
let dtColorsWhite = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.white'
        })
  return (<React.Fragment
>
<Popover
  viewPath={`${viewPath}/Popover`}
 showOnClick={false}
 showOnHover={true}
 placement="right"
 offsetMainAxis={dtSpaceXs}
>
{childProps => (
<React.Fragment>
<fromFlow.When is={flowValue === 'PopoverTrigger'}>
<PopoverTrigger
{...childProps}
  viewPath={`${viewPath}/PopoverTrigger`}
>
{childProps => (
<TysiaButton
{...childProps}
  viewPath={`${viewPath}/TysiaButton`}
 marginLeft={dtSpaceXs}
 marginRight={-7}
 alignSelf="center"
 onClick={() => setFlowTo(fromFlow.normalizePath(viewPath, 'Content'))}
 isSelected={flow.has(fromFlow.normalizePath(viewPath, 'Content'))}
 data="auth.api_role"
 data="reusable_methods.payments_tokens"
 aggregate="helpers.js isDisabled"
 disabled={aggregateData}
 type="ghost"
>
{childProps => (
<TysiaButtonIcon
{...childProps}
  viewPath={`${viewPath}/TysiaButtonIcon`}
>
{childProps => (
<Tysiav2DeleteFilled
{...childProps}
  viewPath={`${viewPath}/Tysiav2DeleteFilled`}
 width={18}
 height={18}
 fill2={aggregateData1 ? dtColorsNeutral300 : dtColorsNeutral500}
 data="auth.api_role"
 data="reusable_methods.payments_tokens"
 aggregate="helpers.js isDisabled"
/>
)}
</TysiaButtonIcon>
)}
</TysiaButton>
)}
</PopoverTrigger>
</fromFlow.When>
<fromFlow.When is={aggregateData2}>
<PopoverContentHover
{...childProps}
  viewPath={`${viewPath}/PopoverContentHover`}
 cursor="not-allowed"
 data="auth.api_role"
 data="reusable_methods.payments_tokens"
 aggregate="helpers.js isDisabled"
>
{childProps => (
<Tooltip
{...childProps}
  viewPath={`${viewPath}/Tooltip`}
 backgroundColor={dtColorsWhite}
 color={dtColorsNeutral500}
 height="auto"
 className="new-shadow"
 whiteSpace="normal"
 text="At least one card must be kept on file"
 className="new-shadow"
/>
)}
</PopoverContentHover>
</fromFlow.When>
</React.Fragment>
)}
</Popover>
<fromFlow.When is={flowValue === 'No'}>
<No
  viewPath={`${viewPath}/No`}
/>
</fromFlow.When>
<fromFlow.When is={flowValue === 'Content'}>
<Content
  viewPath={`${viewPath}/Content`}
/>
</fromFlow.When>
{children}
</React.Fragment>)
}